import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import EntryButton from "../atoms/buttons/EntryButton.jsx";

export default function FloatingActionTrigger() {
    const actionContainer = useRef();
    const floatingContainerState = useSelector(state => state.componentState.floatingContainerState);

    useEffect(() => {
        const containerElement = actionContainer.current;
        if (!floatingContainerState) {
            containerElement.style.display = "none";
        } else {
            containerElement.style.display = "flex";
        }
    }, [floatingContainerState]);

    return (
        <div ref={ actionContainer } className="floating-action-container">
            <EntryButton/>
        </div>
    );
};
